export default __webpack_public_path__ + "static/media/monitoring.48a7e540.svg";